/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Einverstaendnisentbindungvonverschwiegenheit3Inputs */

const de__field_einverstaendnisentbindungvonverschwiegenheit3 = /** @type {(inputs: _Field_Einverstaendnisentbindungvonverschwiegenheit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufsichtspflicht`)
};

/**

* @param {_Field_Einverstaendnisentbindungvonverschwiegenheit3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_einverstaendnisentbindungvonverschwiegenheit3 = /** @type {((inputs?: _Field_Einverstaendnisentbindungvonverschwiegenheit3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Einverstaendnisentbindungvonverschwiegenheit3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_einverstaendnisentbindungvonverschwiegenheit3(inputs)
});
export { _field_einverstaendnisentbindungvonverschwiegenheit3 as "_field_einverstaendnisEntbindungVonVerschwiegenheit" }